module.exports = __webpack_public_path__ + "img/invoice.401f800e.png";